export default __webpack_public_path__ + "static/media/mileshow.a570368a.svg";